export const RequiredMark = () => (
  <span aria-hidden="true" className="ml-0.5 text-red-500">
    *
  </span>
);
